import React from 'react';
import { motion } from 'framer-motion';
import { BatteryWarning, BrainCircuit, HeartCrack, Hourglass } from 'lucide-react';
const problems = [{
  icon: Hourglass,
  text: "Estás trabajando duro. Estás siguiendo los 'hacks' de productividad. Estás sacrificando horas de sueño. Y sin embargo... sientes que algo no encaja."
}, {
  icon: BrainCircuit,
  text: 'Vives en una ansiedad constante por el futuro y la incertidumbre del mercado.'
}, {
  icon: BatteryWarning,
  text: 'Sientes que avanzas solo con tus propias fuerzas, agotando tu energía vital.'
}, {
  icon: HeartCrack,
  text: 'Tu éxito financiero (o la búsqueda de él) no se traduce en paz espiritual ni familiar.'
}];
export function ProblemSection() {
  return <section className="py-24 bg-cream-50 border-y border-brown-900/10" data-id="element-148">
      <div className="max-w-4xl mx-auto px-4" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-150">
          <h2 className="text-sm font-bold tracking-widest text-red-500 uppercase mb-4" data-id="element-151">
            El Problema
          </h2>
          <h3 className="text-4xl md:text-5xl font-heading text-brown-900 mb-6" data-id="element-152">
            El "Éxito" Que Agota
          </h3>
          <div className="w-24 h-px bg-gradient-to-r from-transparent via-red-500/50 to-transparent mx-auto" data-id="element-153" />
        </motion.div>

        <div className="grid gap-6 md:gap-8 mb-16" data-id="element-154">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-6 p-6 md:p-8 rounded-2xl bg-cream-200/80 border border-brown-900/8 hover:border-red-500/20 transition-colors" data-id="element-155">
              <div className="p-3 rounded-full bg-red-500/10 text-red-500 shrink-0" data-id="element-156">
                <problem.icon className="w-6 h-6" data-id="element-157" />
              </div>
              <p className="text-lg text-brown-800 leading-relaxed pt-1" data-id="element-158">
                {problem.text}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="p-8 md:p-10 rounded-2xl bg-gradient-to-br from-cream-100 to-cream-50 border border-terra-500/20 text-center relative overflow-hidden" data-id="element-159">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-terra-500 to-transparent opacity-50" data-id="element-160" />
          <p className="text-xl md:text-2xl font-heading text-brown-900 leading-relaxed" data-id="element-161">
            La Biblia y los grandes líderes de la historia guardan un secreto:{' '}
            <span className="text-terra-500 italic" data-id="element-162">
              El éxito real se establece primero en el cielo.
            </span>{' '}
            Si no estás alineado con las reglas del Creador, cualquier triunfo
            terrenal será frágil y temporal.
          </p>
        </motion.div>
      </div>
    </section>;
}